import React from "react"
import { FaTwitter, FaLinkedin, FaInstagram, FaGithub } from "react-icons/fa"
import { Link } from "gatsby"
const Footer = () => {
  return (
    <section className="bg-dark">
      <div className="">
        <div className="bg-secondary h-auto lg:mx-0 rounded-lg px-6 py-12 md:px-10 md:pt-32 md:pb-16">
          <div className="flex justify-around items-center text-center md:text-left flex-wrap">
            <div className="">
              <h2 className="text-lg md:text-xl xl:text-2xl text-white pb-1 md:pb-3 font-metropolis font-medium">
                ABHISHEK GAUTAM
              </h2>
              <p className="text-xs md:text-sm xl:text-lg text-white opacity-75 font-metropolis font-light md:pt-1 tracking-wide">
                Copyright © 2021 | All rights reserved.
              </p>
            </div>
            <div className="mt-10 md:mt-0">
              <div className="pb-3 text-sm md:text-base xl:text-lg text-white font-metropolis font-light md:pt-1 tracking-wide">
                <Link
                  to="/"
                  className="text-yellow-500 hover:underline cursor-pointer"
                >
                  Home
                </Link>{" "}
                |{" "}
                <Link
                  to="/projects"
                  className="text-yellow-500 hover:underline cursor-pointer"
                >
                  Projects
                </Link>{" "}
                |{" "}
                <Link
                  to="/contact"
                  className="text-yellow-500 hover:underline cursor-pointer"
                >
                  Contact
                </Link>
              </div>
              <div className="flex justify-center items-center text-base md:text-lg text-yellow-100 space-x-6 pt-1 md:pt-1">
                <Link to="https://twitter.com/helloAbhishekk" target="_blank">
                  <FaTwitter className="text-2xl lg:text-2xl hover:text-yellow-400 transition-all duration-500 ease-in-out" />
                </Link>
                <Link
                  to="https://www.linkedin.com/in/abhishek-gautam-54684a167/"
                  target="_blank"
                >
                  <FaLinkedin className="text-2xl lg:text-2xl hover:text-yellow-400 transition-all duration-500 ease-in-out" />
                </Link>
                <Link
                  to="https://www.instagram.com/hello_abhishekk/"
                  target="_blank"
                >
                  <FaInstagram className="text-2xl lg:text-2xl hover:text-yellow-400 transition-all duration-500 ease-in-out" />
                </Link>
                <Link to="https://github.com/AbhishekkGautam" target="_blank">
                  <FaGithub className="text-2xl lg:text-2xl hover:text-yellow-400 transition-all duration-500 ease-in-out" />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Footer
